import cranes from "./cranes.mjs";
import lifts from "./lifts.mjs";
import trailers from "./trailers.mjs";
import axles from "./axles.mjs";

const vehicles =
{
    cranes,
    trailers,
    axles,
    lifts
}

export default vehicles;
